String.prototype.toDisplayDate = function () {
  const date = new Date(this);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
const day = date.getDate().toString().padStart(2, "0");
  return `${day}-${months[date.getMonth()]}-${date.getFullYear()}`;
};

String.prototype.getExpiryStatus = function () {
  const date = new Date(this);
  const now = new Date();

  const diffDays = Math.ceil((date - now) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return "EXPIRED";
  if (diffDays <= 30) return "WARNING";
  return "VALID";
};